module.exports = __webpack_public_path__ + "img/manageModelImg1.bbc5cfe5.png";